import React, { useEffect, useState, useCallback } from "react";
import RideCard from "./RideCard";
import { fetchSuggestedRides } from "../utils/api";
import AdBanner from "./ads/AdBanner";

export default function Suggestion({ filters, user }) {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadSuggestions = useCallback(async () => {
    if (!filters.from || !filters.to) return;
    
    try {
      setLoading(true);
      const data = await fetchSuggestedRides(filters);
      
      // ✅ FIX 1: Prevent crash if API returns an object instead of a raw array
      const ridesArray = Array.isArray(data) ? data : (data?.rides || data?.data || []);
      
      const activeSuggestions = ridesArray
        .filter(ride => {
          const rideDate = new Date(ride.date);
          const today = new Date();
          today.setHours(0, 0, 0, 0);

          const isCancelled = ride.status === 'cancelled';
          const isCompleted = ride.completed === true || ride.status === 'completed';
          const isPast = rideDate < today;

          // ✅ FIX 2: PASSENGER FILTER
          // Checks if the ride has enough seats for what the user searched
          const requestedPassengers = parseInt(filters.passengers) || 1;
          const hasEnoughSeats = (ride.seatsAvailable || 0) >= requestedPassengers;

          // ✅ FIX 3: DATE FILTER (Optional for "Flexible" matches)
          // If you want flexible matches to ignore the exact date and just show nearby routes, 
          // you can remove this block. Otherwise, this enforces the date.
          let matchesDate = true;
          if (filters.date) {
            const searchDate = new Date(filters.date);
            matchesDate = 
              rideDate.getFullYear() === searchDate.getFullYear() &&
              rideDate.getMonth() === searchDate.getMonth() &&
              rideDate.getDate() === searchDate.getDate();
          }

          // Combine all checks: Ride must be active, have seats, and match the date
          return !isCancelled && !isCompleted && !isPast && hasEnoughSeats && matchesDate;
        })
        .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));

      setSuggestions(activeSuggestions);
    } catch (error) {
      console.error("Failed to fetch suggestions:", error);
      setSuggestions([]);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    loadSuggestions();
  }, [loadSuggestions]);

  if (loading) {
    return (
      <section className="suggestion-loading" style={{ marginTop: 32, textAlign: "center" }}>
        <div className="card" style={{ color: "#64748b", padding: "30px", border: "2px dashed #3b82f6", borderRadius: "20px" }}>
          🔍 Finding flexible matches near your route...
        </div>
      </section>
    );
  }

  if (suggestions.length === 0) {
    return (
      <section style={{ marginTop: 32 }}>
        <div className="card" style={{ color: "#94a3b8", textAlign: "center", padding: "30px", borderRadius: "20px" }}>
          No flexible matches found nearby.
        </div>
      </section>
    );
  }

  return (
    <section className="suggestion-section" style={{ marginTop: 40 }}>
      <div style={{ marginBottom: 20 }}>
        <h2 style={{ color: "#3b82f6", fontSize: "22px", fontWeight: "800", margin: 0 }}>
          🚗 Flexible Matches ({suggestions.length})
        </h2>
        <p style={{ fontSize: "13px", color: "#64748b", marginTop: 4 }}>
          Newest rides passing within {filters.radius || 200} km of your route
        </p>
      </div>

      <div className="grid grid-2">
        {suggestions.map((ride, index) => (
          <React.Fragment key={`${ride._id}-${index}`}>
            <div className="suggestion-wrapper" style={{ position: "relative" }}>
              <div style={{
                position: "absolute", top: 12, right: 12,
                background: "rgba(59, 130, 246, 0.9)", backdropFilter: "blur(4px)",
                color: "white", padding: "4px 10px", borderRadius: "10px",
                fontSize: "11px", fontWeight: "800", zIndex: 10,
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
              }}>
                ✨ FLEXIBLE
              </div>
              <RideCard ride={ride} user={user} />
            </div>

            {(index + 1) % 4 === 0 && (
              <div style={{ gridColumn: "1 / -1", margin: "15px 0", display: "flex", flexDirection: "column", alignItems: "center" }}>
                <span style={{ fontSize: "10px", color: "#94a3b8", fontWeight: "700", textTransform: "uppercase", marginBottom: "4px", alignSelf: "flex-start" }}>
                  Sponsored
                </span>
                <AdBanner type="inline" />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
}